<template>
    <div class="login">
      <div v-if="from !== 'store' && pageShow" style="position: relative;">
        <p class='login_tips'>{{$t('inputLogCode')}}</p>
        <van-cell-group class="code_input">
          <van-field type="digit" ref="codeInput0" maxlength="6" @input="inputHandle" cursor="{codeValue[0].length}" :disabled="codeValue.join('').length !== 0 && codeValue.join('').length !== 1" v-model="codeValue[0]"/>
          <van-field type="digit" ref="codeInput1" maxlength="6" @input="inputHandle" cursor="{codeValue[1].length}" :disabled="codeValue.join('').length !== 1 && codeValue.join('').length !== 2" v-model="codeValue[1]"/>
          <van-field type="digit" ref="codeInput2" maxlength="6" @input="inputHandle" cursor="{codeValue[2].length}" :disabled="codeValue.join('').length !== 2 && codeValue.join('').length !== 3" v-model="codeValue[2]"/>
          <van-field type="digit" ref="codeInput3" maxlength="6" @input="inputHandle" cursor="{codeValue[3].length}" :disabled="codeValue.join('').length !== 3 && codeValue.join('').length !== 4" v-model="codeValue[3]"/>
          <van-field type="digit" ref="codeInput4" maxlength="6" @input="inputHandle" cursor="{codeValue[4].length}" :disabled="codeValue.join('').length !== 4 && codeValue.join('').length !== 5" v-model="codeValue[4]"/>
          <van-field type="digit" ref="codeInput5" maxlength="6" @input="inputHandle" cursor="{codeValue[5].length}" :disabled="codeValue.join('').length !== 5 && codeValue.join('').length !== 6" v-model="codeValue[5]"/>
        </van-cell-group>
        <!-- <van-password-input
            :value="codeValue"
            :mask="false"
            :focused="showKeyboard"
            @focus="kbShow"
            :gutter="4"
        /> 
        <van-number-keyboard
        v-model="codeValue"
        :show="showKeyboard"
        /> -->
        <div style="text-align: center; margin-top: 10px">
          <!-- <span class="p_link" is-link @click="copyHandle">{{$t('clickToCopy')}}</span> -->
          <span class="p_link" is-link @click="popShow = true">{{$t('howToGetLogCode')}}</span>
        </div>
        <van-button type="danger" size="large" style="margin: 20px 10px 0;" @click="loginHandle">{{$t('login')}}</van-button>
        <!--国内展示 -->
        <div v-if="env == 'cn' && showIll" style="font-size: 12px;padding: 20px 10px;">充值说明：<br />1、充值仅限于<span style="color:red;">【官方大区】</span>用户使用；<br />2、需要将游戏版本更新到<span style="color:red;">1.12.000</span>以上。</div>
        <van-overlay :show="show">
          <div class="wrapper" @click.stop>
            <van-loading type="spinner" color="#e60012" style=""/>
          </div>
        </van-overlay>
      </div>
      <div v-else-if="from == 'store' && crLoading == 'loaded' && pageShow">
        <p class='login_tips'>{{$t('logRoleSelect')}}</p>
        <van-field
          v-if="roleColumns.length > 0"
          v-model="role"
          is-link
          readonly
          :placeholder="$t('selectRoll')"
          @click="roleShow = true"
        />
        <van-field
          v-else-if="roleColumns.length == 0"
          readonly
          :placeholder="$t('signOOT')"
        />
        <van-popup v-model="roleShow" round position="bottom">
          <van-picker
            show-toolbar
            :title="$t('selectRoll')"
            :columns="roleColumns"
            @confirm="onRoleConfirm"
            @cancel="roleShow = false"
            :confirm-button-text = "$t('sure')"
            :cancel-button-text = "$t('cancel')"
          />
        </van-popup>
        <div style="text-align: center; margin-top: 10px">
          <span class="p_link" is-link @click="toLogin">{{$t('logNewRole')}}</span>
        </div>
        <van-button type="danger" size="large" style="margin: 20px 10px 0;" @click="roleHandle">{{$t('login')}}</van-button>
      </div>
      <van-dialog v-if="env == 'cn'" v-model="popShow" :title="$t('howToGetLogCode')" :confirm-button-text="$t('sure')" :close-on-click-overlay="true">
        <p>在游戏内点击获取登录码按钮</p>
        <img :src="cnImg">
      </van-dialog>
      <van-dialog v-if="env !== 'cn'" v-model="popShow" :title="$t('howToGetLogCode')" :confirm-button-text="$t('sure')" :close-on-click-overlay="true">
        <p>1.{{$t('popTips1')}}</p>
        <img v-if="imgBox[lang]" :src="imgBox[lang].img1">
        <p>2.{{$t('popTips2')}}</p>
        <img v-if="imgBox[lang]" :src="imgBox[lang].img2">
      </van-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapGetters, mapActions} from 'vuex';
import { Toast } from 'vant';
import qs from 'qs';
import {isIosWhite} from '../utils/utils'
import { Dialog } from 'vant';
export default {
  name: 'Store',
  data(){
    return{
        showIll: window.location.host.split('.')[0] === 'jws2mall',
        codeValue: [],
        showKeyboard: true,
        show: false,
        roleShow: false,
        role: '',
        roleColumns: [],
        storage: localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : [],
        from: '',
        popShow: false,
        role: '',
        lang: '',
        selectData: {},
        env: "",
        diffLength: 0, //记录纯数组长度 与 删除后有空值的数组的差
        cnImg: require('@/assets/cn-img.jpg'),
        isNtplat: false,
        pageShow: false,
        imgBox: {
          'zh-CN': {
            img1: require('@/assets/zh-img1.png'),
            img2: require('@/assets/zh-img2.png'),
          },
          'en-US': {
            img1: require('@/assets/en-img1.jpg'),
            img2: require('@/assets/en-img2.jpg'),
          },
          'ja-JP': {
            img1: require('@/assets/jp-img1.jpg'),
            img2: require('@/assets/jp-img2.jpg'),
          },
          'th-TH': {
            img1: require('@/assets/en-img1.jpg'),
            img2: require('@/assets/en-img2.jpg'),
          },
          'id-ID': {
            img1: require('@/assets/id-img1.jpg'),
            img2: require('@/assets/id-img2.jpg'),
          },
          'zh-TW': {
            img1: require('@/assets/hk-img1.jpg'),
            img2: require('@/assets/hk-img2.jpg'),
          },
          'zh-HK': {
            img1: require('@/assets/hk-img1.jpg'),
            img2: require('@/assets/hk-img2.jpg'),
          },
          'ru-RU': {
            img1: require('@/assets/ru-img1.png'),
            img2: require('@/assets/ru-img2.png'),
          },
          'ko-KR': {
            img1: require('@/assets/ko-img1.jpg'),
            img2: require('@/assets/ko-img2.jpg'),
          }
        }
    }
  },
  methods: {
    ...mapActions(['thirdPayLogin', 'getAllPayMode', 'checkRolesToken', 'thirdPayDrLogin','trackLog']),
    isiOS() {
      // 检测 userAgent
      const userAgent = window.navigator.userAgent;
      const isiOSFromUA = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      
      // 检测 platform
      const platform = window.navigator.platform;
      const isiOSFromPlatform = ['iPad', 'iPhone', 'iPod'].includes(platform);
      
      // 检测 macOS 上的 iPad
      const isMacWithTouch = platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;
      
      return isiOSFromUA || isiOSFromPlatform || isMacWithTouch;
    },
    inputHandle(data){
    },
    kbShow(){
      this.showKeyboard = true
    },
    inputHandle(){
      this.diffFlag = false
    },
    loginHandle(){
      this.thirdPayLogin({
        loginCode: this.codeValue.join('')
      })
      this.show = true
    },
    onRoleConfirm(data){
      this.role = data.text
      this.selectData = this.cRoleList.validGameRole.filter(v => v.accessToken == data.value)[0]
      window.localStorage.setItem('accessToken', this.selectData.accessToken)
      window.localStorage.setItem('appId', this.selectData.appId)
      window.localStorage.setItem('roleName', this.selectData.roleName)
      if(this.selectData.serverName && this.selectData.serverName !== '0'){
        window.localStorage.setItem('serverName', this.selectData.serverName)
      }
      // window.localStorage.setItem('storage', this.selectData.storage)
      window.localStorage.setItem('tabActive', '')
      this.roleShow = false
    },
    roleHandle(){
      this.getAllPayMode({
        appId: this.selectData.appId,
        language: this.selectData.language,
        accessToken: this.selectData.accessToken
      })
    },
    toLogin(){
      this.from = ''
      this.$router.push({
        path: '/login'
      })
    },
    getCookiesObj() { 
      return document.cookie.split(';').reduce((f, sv) => {
          let _sv = sv.trim().split('=').map(v => {
              return v.trim()
          })
          f[_sv[0]] = _sv[1]   
          return f  
      }, {})
    },
  },
  computed:{
    ...mapGetters(['status', 'loading', 'userInfo', 'payModeInfo', 'pmLoading', 'cRoleList', 'crLoading', 'userDrInfo', 'drLoading'])
  },
  mounted(){
    this.env = CONFIG.env
    this.from = this.$route.query.from
    this.lang = window.localStorage.getItem('language') || 'en-US'
    //  Dialog.confirm({
    //     title: this.$t('sureAgain'),
    //     message: window.navigator.userAgent,
    //     cancelButtonText: this.$t('cancel'),
    //     confirmButtonText: this.$t('sure')
    //   })
      // 获取浏览器内核
    //  try {
    //   // 判断设备是否为ios 解决whale浏览器无法访问输入框问题
    //     if(typeof(ntAndroidWeb) !== 'undefined' || (window.webkit && window.webkit.messageHandlers&&!isIosWhite())){
    //       this.isNtplat = true
    //       this.pageShow = false
    //     } else {
    //       this.isNtplat = false
    //       this.pageShow = true
    //     }
    //  } catch (error) {
        this.isNtplat = false
        this.pageShow = true
    //  }
  
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).areaId)
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).roleId)
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).serverId)
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(this.getCookiesObj() && this.getCookiesObj()['uid'])
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).deviceId)
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appId)
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']))
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(navigator.userAgent && (navigator.userAgent.split('/').length > 8) && navigator.userAgent.split('/')[9].split('=')[1])
    
    if(this.isNtplat){
      this.thirdPayDrLogin({
        uid: this.getCookiesObj() && this.getCookiesObj()['uid'] || '',
        deviceId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).deviceId || '',
        appId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appId || '',
        accessToken: this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']) || '',
        areaId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).areaId || '1',
        roleId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).roleId || '',
        serverId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).serverId || '',
        language: navigator.userAgent && (navigator.userAgent.split('/').length > 8) && navigator.userAgent.split('/')[9].split('=')[1],
        clientPlat: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).clientPlat || '',
      })
      // this.trackLog({
      //   businessType:'mall',
      //   deviceId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).deviceId || '',
      //   appId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appId || '',
      //   paramData:JSON.stringify(
      //       {
      //           ...JSON.parse(ntAndroidWeb.getDeviceInfo()),
      //           ...JSON.parse(ntAndroidWeb.getPlatAppInfo()),
      //           ...JSON.parse(ntAndroidWeb.getCpCustomParams())
      //       }
      //   )
      // })
    }
    if(!this.$route.query.from){
      if(this.storage && this.storage.length > 0 && !this.isNtplat){
          this.$router.push({
            path: '/store',
            query: this.$route.query
          })
      } else {
        // navigator.clipboard.readText().then(val => {
        //   if(val.length === 6){
        //     this.codeValue = val.split('')
        //   }
        // })
      }
    } else if(this.$route.query.from == 'store'){
      let tokenList = this.storage.map(val => {
        return val.accessToken
      })
      this.checkRolesToken(qs.stringify({
        tokenList: tokenList
      }))
    } else if(this.$route.query.from == 'error'){
      // navigator.clipboard.readText().then(val => {
      //   if(val.length === 6){
      //     this.codeValue = val.split('')
      //   }
      // })
    } else {
      // navigator.clipboard.readText().then(val => {
      //   if(val.length === 6){
      //     this.codeValue = val.split('')
      //   }
      // })
    }
    this.$nextTick(val => {
      this.$refs['codeInput0'].focus()
    })
    this.$watch(() => window.i18n.locale, val => {
      this.lang = val
    })
    this.$watch('crLoading', val => {
      if(val === 'loaded'){
        window.localStorage.setItem('storage', JSON.stringify(this.cRoleList.validGameRole))
        this.roleColumns = this.cRoleList.validGameRole.map(v => {
          let returnData = {}
          returnData.text = v.roleName + ((v.serverName && (v.serverName !== '0')) ? ('(' + v.serverName + ')') : '')
          returnData.value = v.accessToken
          return returnData
        })
      }
    })
    this.$watch('pmLoading', val => {
      if(val === 'loaded'){
        if(this.payModeInfo.paymentInfo.length > 0){
          this.$router.push({
            path: '/store',
            query: this.$route.query
          })
          return false
        }
        Toast({
          message: this.$t('logError'),
          type: "fail"
        })
      }
    })
    this.$watch('drLoading', val => {
      if(val === 'loaded'){
        if(this.status == 0){
          this.show = false
          this.storage.push({
            accessToken: this.userDrInfo.loginResp.accessToken,
            language: this.userDrInfo.loginResp.language,
            appId: this.userDrInfo.loginResp.appId,
            uid: this.userDrInfo.loginResp.uid || '',
            roleName: this.userDrInfo.loginResp.roleName,
            serverName: this.userDrInfo.loginResp.serverName,
            isUseLogin: this.userDrInfo.loginResp.isUseLogin
          })
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          window.localStorage.setItem('accessToken', this.userDrInfo.loginResp.accessToken || '')
          window.localStorage.setItem('appId', this.userDrInfo.loginResp.appId)
          window.localStorage.setItem('uid', this.userDrInfo.loginResp.uid || '')
          window.localStorage.setItem('roleName', this.userDrInfo.loginResp.roleName)
          if(this.userDrInfo.loginResp.serverName && this.userDrInfo.loginResp.serverName !== '0'){
            window.localStorage.setItem('serverName', this.userDrInfo.loginResp.serverName)
          }
          window.localStorage.setItem('isUseLogin', this.userDrInfo.loginResp.isUseLogin)
          setTimeout(() => {
            this.$router.push({
              path: '/detail'
            })
          }, 500)
        }
      }
    })
    this.$watch('loading', val => {
      if(val === 'loaded'){
        if(this.status == 0){
          this.show = false
          // this.storage.splice(this.storage.findIndex(v => v.accessToken == this.userInfo.loginResp.roleInfo.accessToken), 1)
          // console.log(this.storage)
          this.storage.push({
            accessToken: this.userInfo.loginResp.accessToken,
            language: this.userInfo.loginResp.language,
            appId: this.userInfo.loginResp.appId,
            uid: this.userInfo.loginResp.uid || '',
            roleName: this.userInfo.loginResp.roleName,
            serverName: this.userInfo.loginResp.serverName,
            isUseLogin: this.userInfo.loginResp.isUseLogin
          })
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          window.localStorage.setItem('accessToken', this.userInfo.loginResp.accessToken || '')
          window.localStorage.setItem('appId', this.userInfo.loginResp.appId)
          window.localStorage.setItem('uid', this.userInfo.loginResp.uid || '')
          window.localStorage.setItem('roleName', this.userInfo.loginResp.roleName)
          if(this.userInfo.loginResp.serverName && this.userInfo.loginResp.serverName !== '0'){
            window.localStorage.setItem('serverName', this.userInfo.loginResp.serverName)
          }
          window.localStorage.setItem('isUseLogin', this.userInfo.loginResp.isUseLogin)
          if(this.userInfo.loginResp.isUseLogin){
            setTimeout(() => {
              this.$router.push({
                path: '/paylogin'
              })
            }, 500)
          } else {
            setTimeout(() => {
              this.$router.push({
                path: '/store',
                query: this.$route.query
              })
            }, 500)
          }
        } else {
          Toast({
            message: this.$t('checkLogCode'),
            type: "fail"
          })
          this.show = false
        }
      }
    })
    this.$watch('codeValue', (oldVal, val) => {
      let k = (val.filter(v => v !== '').length - 1)
      let v = val[k]
      if (v.length == 2){
        this.$nextTick(nVal => {
          this.$refs[`codeInput` + k].value = parseInt(v / 10) % 10
          this.$refs[`codeInput` + (k + 1)].focus()
        })
      } else if(v.length == 6){
        this.codeValue = v.split('')
        this.$nextTick(nVal => {
          this.$refs[`codeInput5`].focus()
        })
      } else  if(v.length == 1){
        if((this.diffLength < (val.length - 1) - k)){
          this.codeValue = []
          this.$nextTick(nVal => {
            this.$refs[`codeInput0`].focus()
          })
          // let changeVal = JSON.stringify(JSON.parse(v))
          // this.diffLength = (val.length - 1) - k
          // this.$nextTick(nVal => {
          //     this.$refs[`codeInput` + (val.join('').length - 1)].selectionStart = this.$refs[`codeInput` + (val.join('').length - 1)].selectionEnd = 1
          //   this.$refs[`codeInput` + (val.join('').length - 1)].focus()
          //   this.$refs[`codeInput` + (val.join('').length - 1)].value = ''
          //   this.$refs[`codeInput` + (val.join('').length - 1)].value = changeVal
          //   setTimeout(() => {
          //   }, 100)
          // })
        } else if((this.diffLength > (val.length - 1) - k)){
          this.diffLength = (val.length - 1) - k
          this.$nextTick(nVal => {
            this.$refs[`codeInput` + (k + 1)].focus()
          })
        } else {
          this.$nextTick(nVal => {
            this.$refs[`codeInput` + (k + 1)].focus()
          })
        }
      } else {
        this.codeValue = []
        this.$nextTick(nVal => {
          this.$refs[`codeInput` + k].value = ''
        })
      }
      // if(val.filter(v => v !== '').length=== 6){
      //   this.thirdPayLogin({
      //     loginCode: val.join('')
      //   })
      //   this.show = true
      // }
    })
  }
}
</script>

<style lang="scss">
.login{
  position: relative;
  margin: 10px;
  // .van-number-keyboard{
  //   position: relative;
  // }
  .code_input{
    display: flex;
    justify-content: space-around;
    margin: 0 16px;
    background-color: transparent;
    .van-cell{
      width: 14%;
      padding: 0;
      background-color: transparent;
    }
    input{
      height: 40px;
      text-align: center;
      background-color: #e9e9e9;
      border-radius: 6px;
      border: 0;
      &:disabled{
        color: #323233;
        -webkit-text-fill-color: #323233;
      }
      &:focus{
        background-color: #fff;
        border: 1px solid #e60012;
      }
    }
  }
  .van-field__control:read-only{
    text-overflow: ellipsis;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login_tips{
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
  .van-password-input__security{
        li{
            background-color: #e9e9e9;
            border-radius: 6px;
            &.van-password-input__item--focus{
                background-color: #fff;
                border: 1px solid #e60012;
            }
        }
  }
  .van-password-input__security{
      height: 45px;
  }
  .van-overlay{
    z-index: 101;
  }
  .p_link{
    text-align: center;
    margin-top: 20px;
    font-size: 10px;
    color: #e60012;
    text-decoration: underline;
    padding: 0 10px;
  }
  .van-dialog{
    max-height: 90vh;
    overflow-y: scroll;
    margin-top: 5vh;
  }
  .van-dialog__content{
    p{
      text-align: center;
    }
    img{
      width: 60%;
      position: relative;
      left: 20%;
    }
  }
}
</style>
